<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-7"></a>
<h1 class="head">Scenes</h1>
<h2 class="toc2"><a href="#/xhtml/Chapter1#Part1">ACT ONE</a></h2>
<h3 class="toc3"><a href="#/xhtml/Chapter1#ch1">Scene One. The living room of the Callifers’ house, Wild Grove, in what was once the country. An autumn afternoon.</a></h3>
<h3 class="toc3"><span href="#/xhtml/Chapter2#ch2" title="Link target outside of Sample">Scene Two. The same. Evening, two days later.</span></h3>
<h2 class="toc2"><span href="#/xhtml/Chapter3#Part2" title="Link target outside of Sample">ACT TWO</span></h2>
<h3 class="toc3"><span href="#/xhtml/Chapter3#ch3" title="Link target outside of Sample">Scene One. James Callifer’s lodgings in Nottingham. Four weeks later.</span></h3>
<h3 class="toc3"><span href="#/xhtml/Chapter4#ch4" title="Link target outside of Sample">Scene Two. Father William Callifer’s presbytery, somewhere in East Anglia. Evening, the next day.</span></h3>
<h2 class="toc2"><span href="#/xhtml/Chapter5#Part3" title="Link target outside of Sample">ACT THREE</span></h2>
<h3 class="toc3"><span href="#/xhtml/Chapter5#ch5" title="Link target outside of Sample">The living room at Wild Grove. The next evening.</span></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2298c78b